export default "__VITE_ASSET__BoTvAEMM__"